import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

interface SignalAIAvatarProps {
  size?: "xs" | "sm" | "md" | "lg";
  className?: string;
}

const avatarSizes = {
  xs: { wrapper: "h-5 w-5", icon: "h-2.5 w-2.5" },
  sm: { wrapper: "h-6 w-6", icon: "h-3 w-3" },
  md: { wrapper: "h-7 w-7", icon: "h-3.5 w-3.5" },
  lg: { wrapper: "h-8 w-8", icon: "h-4 w-4" },
};

export function SignalAIAvatar({ size = "sm", className }: SignalAIAvatarProps) {
  const s = avatarSizes[size];
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center bg-gradient-to-br from-[#342799] via-[#A242A2] to-[#FF534C] rounded-full",
        s.wrapper,
        className,
      )}
    >
      <Sparkles className={cn(s.icon, "text-white")} fill="currentColor" stroke="none" />
    </span>
  );
}
